import React, { useState } from 'react';
import FilterGroup from './FilterGroup';
import { FILTER_GROUPS } from '../config/filterConfig';
import styles from './PropertyFilters.module.scss';

/**
 * Property filters component
 * Displays all 7 filter groups (wuchsformen, bluete_frucht_duft, etc.)
 * Collapsible section that auto-expands when filters are active
 *
 * @param {Object} props
 * @param {Object} props.filters - Current filter state {filterKey: [values]}
 * @param {Object} props.availableFilters - Available filter values from API {filterKey: [values]}
 * @param {Function} props.onChange - Callback when filters change
 * @param {Function} props.onReset - Callback to reset all filters
 */
export default function PropertyFilters({ filters, availableFilters = null, onChange, onReset }) {
    const [isOpen, setIsOpen] = useState(false);

    const handleFilterChange = (filterKey, values) => {
        onChange({
            ...filters,
            [filterKey]: values,
        });
    };

    const hasAnyFilters = Object.values(filters).some(arr => arr.length > 0);

    return (
        <div className={styles.propertyFilters}>
            <div
                className={`${styles.heading} ${isOpen || hasAnyFilters ? styles.active : ''}`}
                onClick={() => setIsOpen(!isOpen)}
            >
                <h2>Eigenschaften</h2>
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    width="16"
                    height="16"
                >
                    <path fill="currentColor" d="M7 10l5 5 5-5z" />
                </svg>
            </div>
            {(isOpen || hasAnyFilters) && (
                <ul className={styles.categoryList}>
                    {FILTER_GROUPS.map((group) => (
                        <FilterGroup
                            key={group.handle}
                            title={group.display}
                            handle={group.handle}
                            options={group.options}
                            selected={filters[group.handle] || []}
                            availableValues={availableFilters ? availableFilters[group.handle] : null}
                            onChange={handleFilterChange}
                        />
                    ))}
                </ul>
            )}
        </div>
    );
}
